var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "14px",
    viewBox: "0 0 18 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 6 Copy 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Admin",
    transform: "translate(-841.000000, -440.000000)",
    stroke: "#333333"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(787.000000, 430.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy-3",
    transform: "translate(55.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 12.75,
    y1: 11.6334192,
    x2: 12.75,
    y2: -6.44225414e-13,
    id: "Path-13-Copy",
    transform: "translate(12.750000, 5.816710) scale(1, -1) translate(-12.750000, -5.816710) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.25,
    y1: 11.6334192,
    x2: 4.25,
    y2: 4.02461555e-7,
    id: "Path-13-Copy-2",
    transform: "translate(4.250000, 5.816710) scale(1, -1) translate(-4.250000, -5.816710) "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-14-Copy",
    transform: "translate(12.537500, 9.402169) scale(1, -1) translate(-12.537500, -9.402169) ",
    points: "8.5 11.4209192 12.7648181 7.38341915 16.575 11.4209192"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-14-Copy-2",
    points: "0 4.33758582 4.26481805 0.300085819 8.075 4.33758582"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.1cf46f3b99310316b410604817994c28.svg";
export { ForwardRef as ReactComponent };